'use strict'
//this is the global app for the pages that doesnt use self layout.

if(NgAppName == 'crGenApp'){
	crGenApp = angular.module(NgAppName, ['ngResource', 'ngSanitize', 'ngRoute', 'ngCookies']);
	crGenApp.controller('crGeneralCtrl', function($scope, $rootScope, $timeout, crResourcesService){

	});
}
